<template>
  <div class="BSCButtonSelect">
    <button
      v-for="button in buttons"
      @click="selected(button)"
      :key="button.item"
      class="BSCButtonSelect-buttons"
      :class="[
        `is-${type}`,
        { 'BSCButtonSelect-buttons-selected': button.value === newValue.value }
      ]"
    >
      <span class="BSCButtonSelect-buttons-label">{{ button.label }}</span>

      <div
        v-if="button.img !== undefined && button.img !== null"
        class="BSCButtonSelect-buttons-image"
      >
        <img :src="button.img" />
      </div>
    </button>
  </div>
</template>

<script>
'use strict'

export default {
  name: 'BSCButtonSelect',
  inheritAttrs: false,
  props: {
    value: Object,
    buttons: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'normal'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      newValue: this.value
    }
  },
  methods: {
    selected(el) {
      if (!this.disabled) {
        this.$emit('selected', el)
        this.$emit('input', el)
      }
    }
  },
  watch: {
    value(value) {
      if (!this.disabled) this.newValue = value
    }
  }
}
</script>
